import React, { FC } from 'react'
import { ProductUpsell, Variant } from '@moonpig/web-shared-products'
import { ProductModule } from '../types'
import { ProductModuleSection } from '../ProductModuleSection'
import { useProductContext } from '../../../contexts/product'
import { ProductWithRecommendations } from '../../../components/ProductDetails'

const getSelectedVariant = ({
  product,
  variantKey,
}: {
  product: ProductWithRecommendations
  variantKey: string
}) => {
  return product.variants.find(v => v.key === variantKey)
}

export const ProductUpsellModule: FC<ProductModule> = props => {
  const [
    {
      product,
      upsellProduct,
      selectedOptions: { variantKey },
    },
  ] = useProductContext()

  if (!upsellProduct || !upsellProduct.masterVariant.inStock) {
    return null
  }

  const {
    price: { centAmount, currencyCode, fractionDigits },
  } = getSelectedVariant({
    product,
    variantKey,
  }) as Variant

  return (
    <ProductModuleSection {...props}>
      <ProductUpsell
        upsellProduct={upsellProduct}
        selectedVariantPrice={{ centAmount, currencyCode, fractionDigits }}
        trackingData={{
          pageLocation: 'product details',
          product: { id: product.id },
        }}
      />
    </ProductModuleSection>
  )
}
